import React from "react";
import { useAuth } from "react-oidc-context";
import { Route, Routes, Outlet } from "react-router-dom";
import "../../custom.css";
import SignInOidc from "../SignInOidc/SignInOidc";
import NotAuthenticated from "../../pages/NotAuthenticated/NotAuthenticated";
import NotAuthorized from "../../pages/NotAuthorized/NotAuthorized";
import OverviewPage from "../../pages/OverviewPage/OverviewPage";
import DevicesPage from "../../pages/DevicesPage/DevicesPage";
import ImportExportPage from "../../pages/ImportExportPage/ImportExportPage";
import SupportHelpPage from "../../pages/SupportHelpPage/SupportHelpPage";
import OrgSearchPanel from "../../pages/OrgSearchPanel/OrgSearchPanel";
import ProcessingPage from "../../pages/ProcessingPage/ProcessingPage";
import { useEffect } from "react";
import HeaderAndFooterLayout from "../PageLayouts/HeaderAndFooterLayout";
import NewDCGAutomationAccount from "../NewAccountWizard/NewDCGAutomationAccount";
import SubscriptionConfirmation from "../../pages/DCGAutomation/Pages/SubscriptionConfirmation";
import RedirectToHtml from "../RedirectToHtml/RedirectToHtml";
import Logout from "../Logout/logout";
import HierarchyManagementDashboardPageModel from "../../pages/HierachyManagementDashboard/HierarchyManagementDashboardPageModel";
import RolesAndPermissionsDashboard from "../../pages/RolesAndPermissionsDashboard/RolesAndPermissionsDashboard";
import UserManagementPage from "../../pages/UserManagement/UserManagementPage";
import NewAccountPage from "../NewAccountWizard/NewAccountPage.js";
import { OldOnboarding } from "../../constants/onboardingVersions.js";
import { DcgAutomation } from "../../constants/onboardingVersions.js";
import InviteProcessingPage from "../../pages/InviteProcessing/InviteProcessingPage";
import InviteInfoPage from "../../pages/UserInvite/InviteInfoPage";
import BootstrapDemo from "../../pages/BootstrapDemo.js";
import DsaRecipientPage from "../../pages/DsaRecipientPage/DsaRecipientPage.js";
import DsaSenderPage from "../../pages/DsaSenderPage/DsaSenderPage";

const OrgPanel = () => {
    const auth = useAuth();
    useEffect(() => {
        // When the user's access token is about to expire, get an updated access token
        return auth.events.addAccessTokenExpiring(() => {
            auth.signinRedirect();
        });
    }, [auth.events, auth.signinRedirect]);
    
    switch (auth.activeNavigator) {
        case "signinSilent":
            return <div>Signing you in...</div>;
        case "signoutRedirect":
            return <div>Signing you out...</div>;
        default:
            break;
    }
    if (auth.isLoading) return <div>Loading...</div>;
    if (auth.error) return <div>Oops... {auth.error.message}</div>;
    
    if (auth.isLoading) return <div>Loading...</div>;

    const ProtectedRoute = ({ isAllowed }) => {
        return isAllowed ? <Outlet /> : <NotAuthenticated />;
    }

    // User is authenticated
    return (
        <Routes>
            {/* user invite page */}
            <Route path="/invite" element={<InviteInfoPage />} />

            {/* demo page for bootsrap */}
            <Route path={`/BootstrapDemo`} element={<BootstrapDemo />} />

            {/* old onboarding flow */}
            <Route path={`/${OldOnboarding}/:formId?`} element={<NewAccountPage />} />
            <Route path={`/${OldOnboarding}/Logout/:redirectUrl?`} element={<Logout />} />
            <Route path={`/${OldOnboarding}/processing`} element={<ProcessingPage />} />

            {/* new onboarding flow ("DCG Automation") */}
            <Route path={`/${DcgAutomation}/:formId?`} element={<NewDCGAutomationAccount />} />
            <Route path={`/${DcgAutomation}/Logout/:redirectUrl?`} element={<Logout />} />
            <Route path={`/requestPortalJoinCode`} element={<RedirectToHtml url="/PortalJoinCode.html" />} />

            {/* protected routes without header and footer */}
            <Route element={<ProtectedRoute isAllowed={auth.isAuthenticated} />}>
                <Route path="/subscriptionConfirmation" element={<SubscriptionConfirmation />} />  
                <Route path="/ProcessInvite" element={<InviteProcessingPage />} />
            </Route>

            <Route element={<HeaderAndFooterLayout />} >
                <Route path="/signin-oidc" element={<SignInOidc />} />
                <Route path="/notauthorized" element={<NotAuthorized />} />
                <Route element={<ProtectedRoute isAllowed={auth.isAuthenticated} />}>
                    <Route path="/Organizations/:orgId/SubOrganizations/:locationId?" element={<HierarchyManagementDashboardPageModel />} />
                    <Route path="/Organizations/:orgId/Devices" element={<DevicesPage />} />
                    <Route path="/Organizations/:orgId/importexport/" element={<ImportExportPage />} />
                    <Route path="/supporthelp" element={<SupportHelpPage />} />
                    <Route path="/overview" element={<OverviewPage />} />
                    <Route path="/overview/:orgId" element={<OverviewPage />} />
                    <Route path="/Organizations/:orgId/overview" element={<OverviewPage />} />
                    <Route exact path="/" element={<OverviewPage />} />
                    <Route path="/Organizations/:orgId/Search" element={<OrgSearchPanel />} />
                    <Route path="/Organizations/:orgId/Locations" element={<HierarchyManagementDashboardPageModel />} />
                    <Route path="/Organizations/:orgId/roles" element={<RolesAndPermissionsDashboard />} />
                    <Route path="/Organizations/:orgId/usermanagement" element={<UserManagementPage />} />

                    {/*DSA Routes*/}
                    <Route path="/Organizations/:orgId/DataSharingAgreements/Received" element={<DsaRecipientPage />} />
                    <Route path="/Organizations/:orgId/DataSharingAgreements/Sent" element={<DsaSenderPage />} />
                </Route>
            </Route>
        </Routes>
    );
};

export default OrgPanel;
